import { globalBuildContext } from 'rlink-router/__globalBuildContextForLegacySupport__';
import pushToNavState from 'rlink-router/actions/pushToNavState';

export default function clearHash () {
  let c = location.hash;
  if (c) {
    let { dispatch } = globalBuildContext.reduxStore;
    dispatch(pushToNavState(globalBuildContext, {view: 'home'}));
  }
  return c;
}



// WEBPACK FOOTER //
// ./apps/www.relic.com/src/helpers/clearHash.js